export default __webpack_public_path__ + "03dbb47b1929b8ded15a4be5d7948f14.wav";